import React from 'react'
import { Link } from 'react-router-dom'
import { renderRoutes, RouteConfigComponentProps, RouteConfig } from 'react-router-config'
import { Layout, Menu } from 'antd'
import Icon from '@ant-design/icons'
import * as SvgIcon from '../../assets/icon'
import { GlobalHeader } from '../../components'
import { getAuth, AuthProps } from '../../utils/global'
import { Watermark } from '../../utils'
import './index.less'
import { addContentType } from '../../redux/reducers/contentType'
import { getCateList } from '../../redux/reducers/category'
import { addCompanyList } from '../../redux/reducers/baseInfo'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as API from '../../api'

const { Sider, Content } = Layout

export interface BasicRouteConfig extends RouteConfig {
	path: string; // 源码里的定义为string|string[] 这里改为只有string 避免和menu item的key的类型相冲突
	routes?: BasicRouteConfig[];
}

interface BasicLayoutProps extends RouteConfigComponentProps {
	route: BasicRouteConfig;
}

interface GroupProps {
	id: string;
	name: string;
}
interface BasicLayoutState {
	auth: AuthProps[];
	authPaths: string[];
	openKeys: string[];
	companyList: GroupProps[];
}

// class BasicLayout extends React.Component<BasicLayoutProps> {
class BasicLayout extends React.Component<any, BasicLayoutState> {
	state: BasicLayoutState = {
		auth: [],
		authPaths: [],
		openKeys: ['/main/content'],
	}
	watermark = new Watermark({
		txt: `同程旅行内部信息，请勿对外转载\n${this.props.userInfo.username} ${this.props.userInfo.ispublicnetwork ? '' : this.props.userInfo.userid}`,
		xSpace: 0,
		width: 310,
		height: 150,
	}, {
		opacity: '0.03',
		color: '#000',
		lineHeight: '26px',
		fontSize: '20px',
		fontWeight: '500',
	})

	/**
	 * 水印
	 */
	handleWatermark = () => {
		if (this.props.location.pathname.includes('main/content')) { // 只在内容库相关页面添加水印
			this.watermark.append()
		} else {
			this.watermark.remove()
		}
	}
	componentDidMount() {
		getAuth('route').then((res: AuthProps[]) => {
			if (res.length === 0) {
				this.props.history.push('/403')
			}
			this.setState({
				auth: res,
				authPaths: res.map(item => item.resourceVal),
			})
			if (this.state.authPaths.includes('/main/category')) this.getCategoryList()
			if (this.state.authPaths.includes('/main/review/waitReview')) this.getCompanyList()
		})
		this.getContentType()
		this.handleWatermark()
		this.getOpenKeys()
	}
	async getCompanyList() {
		const { code, data } = await API.getCompanyList({})
		if (code === 0) {
			this.props.actions.addCompanyList(data)
		} else {
			console.log('获取内容形式失败')
		}
	}
	async getContentType() {
		const { code, data } = await API.getContentType({})
		if (code === 0) {
			this.props.actions.addContentType(data)
		} else {
			console.log('获取内容形式失败')
		}
	}
	getOpenKeys() {
		const route = this.props.route.routes, pathname = this.props.location.pathname
		for (let i = 0; i < route.length; i++) {
			for (let j = 0; j < route[i].routes.length; j++) {
				if (route[i].routes[j].path === pathname || pathname.indexOf(route[i].routes[j].path) > -1) {
					const keys = [route[i].path]
					if (route[i].routes[j].routes.length > 0) {
						keys.push(`${route[i].routes[j].path}/index`)
					}
					this.setState({ openKeys: keys })
					break
				}
			}
		}
	}
	/**
	 * 获取场景分类列表
	 */
	getCategoryList() {
		this.props.actions.getCateList()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this.handleWatermark()
			this.getOpenKeys()
		}
	}
	onOpenChange(keys) {
		this.setState({ openKeys: keys })
	}
	componentWillUnmount() {
		this.watermark.remove()
	}
	render() {
		if (!this.props.route.routes) return
		const childRoutes: BasicRouteConfig[] = this.props.route.routes
		const menuRoutes: BasicRouteConfig[] = childRoutes.map(item => {
			const filterRoutes: any[] = []
			item.routes && item.routes.forEach(route => {
				if (route.hiddenInMenu) return
				filterRoutes.push(route)
			})
			return {
				...item,
				routes: filterRoutes
			}
		})
		const { authPaths, openKeys } = this.state
		const pathname = this.props.location.pathname
		const clearStash = (name) => {
			console.log('=====', name)
			localStorage.removeItem('jumpBeforepageNo')
			localStorage.removeItem('jumpBeforepageSize')
			localStorage.removeItem('jumpBeforeParams')
			localStorage.removeItem('jumpBeforeScrollTop')
		}
		return (
			<Layout className="main">
				<GlobalHeader />
				<Layout className="layout-bottom">
					<Sider className="basic-layout-sider" theme="light" width="180">
						<Menu mode="inline" selectedKeys={pathname === '/main/content/library/addContent' || pathname === '/main/content/library' ? ['/main/content/library/index'] : [pathname]} openKeys={openKeys} onOpenChange={this.onOpenChange.bind(this)}>
							{menuRoutes.map(route => {
								const { path, title, icon, routes, redirect, exclude } = route
								if (!title || !authPaths.includes(path)) return
								if (routes && routes.length) { // 子路由
									return (
										<Menu.SubMenu key={path} title={title} icon={<Icon component={SvgIcon[icon]}></Icon>}>
											{routes.map(route => {
												const { path, title, redirect } = route
												const fullPath = redirect ? path + redirect : path
												// console.log('141',title,path)
												if (!title || !authPaths.includes(path)) return
												// if(title === '增长物料审核' && this.props.companyList.length > 0) {
												// 	return (
												// 		<Menu.SubMenu key={fullPath} title={title}>
												// 			{/* {
												// 				this.props.companyList.map(item => {
												// 					return (
												// 						<Menu.Item key={`${fullPath}/${item.id}`}>
												// 							<Link to={`${fullPath}/${item.id}`} onClick={() => clearStash(title)}>
												// 								<span>{item.company_name}</span>
												// 							</Link>
												// 						</Menu.Item>
												// 					)
												// 				})
												// 			} */}
												// 		</Menu.SubMenu>
												// 	)
												// } else {
												return title && authPaths.includes(path) && (
													<Menu.Item key={fullPath}>
														<Link to={fullPath} onClick={() => clearStash(title)}>
															<span>{title}</span>
														</Link>
													</Menu.Item>
												)
												// }
											})}
										</Menu.SubMenu>
									)
								} else if (title && !exclude) {
									const fullPath = redirect ? path + redirect : path
									return (
										<Menu.Item key={fullPath}>
											<Link to={fullPath}>
												{icon && <Icon component={SvgIcon[icon]}></Icon>}
												<span>{title}</span>
											</Link>
										</Menu.Item>
									)
								}
							})}
						</Menu>
					</Sider>
					<Content className="basic-layout-content" id="basic-layout-content">
						<Content>
							{renderRoutes(childRoutes)}
						</Content>
					</Content>
				</Layout>
			</Layout>
		)
	}
}
function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
		contentType: state.contentType,
		categoryList: state.categoryInfo.cateList,
		companyList: state.baseInfo.companyList
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({
			addContentType,
			getCateList,
			addCompanyList
		}, dispatch)
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(BasicLayout)